import { render, staticRenderFns } from "./HorizontalTopbar.vue?vue&type=template&id=9fa8e046&"
import script from "./HorizontalTopbar.vue?vue&type=script&lang=js&"
export * from "./HorizontalTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports